import { render, staticRenderFns } from "./One_user_transactions.vue?vue&type=template&id=28eed944&"
import script from "./One_user_transactions.vue?vue&type=script&lang=js&"
export * from "./One_user_transactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports